import { Container } from "@/components/Container";
import { Typography } from "@mui/material";

import { SecurityInformationBannerProps } from "./types";

export const SecurityInformationBanner: React.FC<SecurityInformationBannerProps> = ({ title }) => {
  return (
    <Container bgcolor="#FF8B00" py={{ xs: "34px", md: "48px" }} px={{ xs: "24px", sm: "24px", md: "84px", lg: "81px" }} mb="-1px">
      <Typography component="span" color="#FFF" fontSize="32px" fontWeight={600} lineHeight="38.73px" textAlign="left">
        {title}
      </Typography>
    </Container>
  );
};
